/* Schwebende Knoepfe unten rechts (snippets/cl-schwebend.liquid).
   Beide Knoepfe loesen nur die Original-Knoepfe der Apps aus und erscheinen erst,
   wenn es diese gibt. Erst dann werden die Originale versteckt - findet das Skript
   sie nicht (App umgebaut, nicht geladen), bleibt einfach alles wie vorher.

   Judge.me: der Reiter .jdgm-revs-tab-btn oeffnet das Bewertungsfenster, auch versteckt.
   Shopify Forms: kein Weg zum Oeffnen ausser dem Teaser-Knopf im Schatten-DOM der App
   (wie lpc.newsletterOeffnen in snippets/lpc-stil.liquid, gleicher Suchausdruck - die
   Klassen tragen einen Zufallsanhang). Der Teaser wird nur unsichtbar gestellt, damit
   Buersten-Quiz und Tauro-Karten ihn weiter ausloesen koennen. */
(function () {
  var wurzel = document.querySelector('[data-cl-schweb]');
  if (!wurzel) return;
  var pille = wurzel.querySelector('[data-cl-schweb-bewertung]');
  var kreis = wurzel.querySelector('[data-cl-schweb-rabatt]');

  /* Nur der Teaser-Schritt wird unsichtbar - das Anmeldefenster selbst ist ein anderer
     Schritt desselben Elements und bleibt sichtbar. visibility statt display: so bleibt
     der Knopf im Aufbau der App und ist per click() weiter ausloesbar. */
  var TEASER_STIL = '[data-form-root][data-current-step="tease"]{visibility:hidden!important}';

  function judgeReiter() { return document.querySelector('.jdgm-revs-tab-btn'); }
  function formsTeaser() {
    var baustein = document.querySelector('shopify-forms-embed');
    var schatten = baustein && baustein.shadowRoot;
    if (!schatten) return null;
    var knopf = schatten.querySelector('button[class*="teaserContainer"]');
    /* Stil einsetzen, sobald der Teaser da ist; baut die App ihren Schatten neu auf, erneut */
    if (knopf && !schatten.querySelector('style[data-cl-schweb]')) {
      var stil = document.createElement('style');
      stil.setAttribute('data-cl-schweb', '');
      stil.textContent = TEASER_STIL;
      schatten.appendChild(stil);
    }
    return knopf;
  }

  if (pille) {
    pille.addEventListener('click', function () {
      var reiter = judgeReiter();
      if (reiter) reiter.click();
    });
  }
  kreis.addEventListener('click', function () {
    var teaser = formsTeaser();
    if (teaser) teaser.click();
  });

  /* Beide Apps laden sich lange nach dem Seitenaufbau selbst nach, und der Teaser
     kommt und geht (offenes Fenster, Anmeldung). Deshalb im Takt pruefen: anfangs
     schnell, damit der Original-Knopf kaum aufblitzt, danach gemaechlich. */
  var takte = 0;
  function pruefen() {
    if (pille && pille.hidden && judgeReiter()) {
      document.documentElement.classList.add('cl-schweb-jdgm');
      pille.hidden = false;
    }
    kreis.hidden = !formsTeaser();
    takte++;
    setTimeout(pruefen, takte < 60 ? 250 : 1000);
  }
  pruefen();
})();
